/* eslint-disable import/prefer-default-export */

export default {
  appName: 'Imaginarie',
  prodProject: 'imaginarie-app',
  devProject: 'imaginarie-app-dev',

  // URLS
  appUrl: 'https://app.imaginarie.app',
  appUrlText: 'app.imaginarie.app',
  marketingUrl: 'https://imaginarie.app',
  marketingUrlText: 'imaginarie.app',

  // App Links
  iosAppUrl: 'https://apps.apple.com/us/app/imaginarie-fun-meditation/id1514022254',
  androidAppUrl: 'https://play.google.com/store/apps/details?id=app.imaginarie.app',

  // Dynamic links
  openFromEmailVerifiedUrl: 'https://link.imaginarie.app/open-emailverified',
  shareUrl: 'https://link.imaginarie.app/share',
  shareCardUrl: 'https://link.imaginarie.app/card',

  // Email & Social
  supportEmail: 'support@imaginarie.app',
  supportEmailLink: 'mailto:support@imaginarie.app',
  helloEmail: 'hello@imaginarie.app',
  helloEmailLink: 'mailto:hello@imaginarie.app',
  noreplyEmail: 'noreply@imaginarie.app',
  instagramUsername: 'imaginarie.app',
  instagramUrl: 'https://www.instagram.com/imaginarie.app',
  blogUrl: 'https://www.imaginarie.app/blog',

  // App Store & Google Play
  app_store: {
    id: 'app_store',
    name: 'App Store',
    account: 'Apple ID',
    subscriptionsUrl: 'https://apps.apple.com/account/subscriptions',
    billingUrl: 'https://apps.apple.com/account/billing',
  },
  play_store: {
    id: 'play_store',
    name: 'Google Play',
    account: 'Google',
    subscriptionsUrl: 'https://play.google.com/store/account/subscriptions',
    billingUrl: 'https://play.google.com/store/account/subscriptions',
  },

  // Marketing Copy
  tagline: 'Meditation through imagination for creativity, joy, insight, and sleep',

  // Cards & Categories
  allCardsTitle: 'Cards',
  deepeningTitle: 'Deepening',
  deepeningTagline: 'Pure relaxation',
  journeyTitle: 'Journey',
  journeyTagline: 'What will you discover?',
  lighteningTitle: 'Lightening',
  lighteningTagline: 'Boost your energy',
  dailyCardsTitle: 'Daily Cards',
  morningTitle: 'Morning',
  dayTitle: 'Day',
  nightTitle: 'Night',
  stacksTagline: 'Card collections for longer meditations',

  // Tooltips
  dailyCardsInfoTooltip: `<p>Every day you’ll get 3 cards picked just for you. Start your morning upbeat, take the break you need during the day, and end the night with good dreams.</p><p>Find the rest of the 100+ cards in the <strong>Explore</strong> tab below.</p>`,
  stacksInfoTooltip:
    'Playlists are themed sets of cards for different moods and situations, like getting motivated or falling asleep. You can listen to or read the cards in a playlist.',
  lighteningInfoTooltip:
    'The yellow Lightening cards are fun, energizing, and put a smile on your face. Use them any time you want to lighten up and shine!',
  journeyInfoTooltip:
    'Each blue Journey card will take you deeper into your imagination, surprising you with personal insights, inspiration, and delightful images.',
  deepeningInfoTooltip:
    'The purple Deepening cards are calming, soothing, and perfect for drifting into relaxation any time of day.',

  // Auth Intro
  authIntro1: `Relax & lift your mood by taking a few minutes away from <span class="no-wrap">the real world</span>`,
  authIntro2: `Fall asleep to beautiful, restful scenes instead of tomorrow’s <span class="no-wrap">to-do list</span>`,
  authIntro3: `Improve your mental & physical health with the power of <span class="no-wrap">positive thinking</span>`,
  authHome: 'Hop on to explore all the best destinations in your mind',
};
